"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Editor = exports.EDITOR_ID_SEPARATOR = void 0;
const bootstrap_4_1 = __importDefault(require("@rjsf/bootstrap-4"));
const react_1 = __importStar(require("react"));
const ArrayFieldTemplate_1 = __importDefault(require("./Templates/ArrayField/ArrayFieldTemplate"));
const BooleanCustomWidget_1 = __importDefault(require("./Templates/Boolean/BooleanCustomWidget"));
const FieldErrorTemplate_1 = __importDefault(require("./Templates/Error/FieldErrorTemplate"));
const FieldTemplate_1 = __importDefault(require("./Templates/Field/FieldTemplate"));
const DescriptionFieldTemplate_1 = __importDefault(require("./Templates/Description/DescriptionFieldTemplate"));
const ObjectFieldTemplate_1 = __importDefault(require("./Templates/ObjectField/ObjectFieldTemplate"));
const Preconfigured_1 = __importDefault(require("./Preconfigured/Preconfigured"));
const isEmptySchema_1 = require("../../utilities/isEmptySchema/isEmptySchema");
const SchemaField_1 = require("./Templates/SchemaField/SchemaField");
const react_json_schema_utils_1 = require("@squiz/react-json-schema-utils");
const FeatureFlags_1 = require("../../context/FeatureFlags/FeatureFlags");
exports.EDITOR_ID_SEPARATOR = `~`;
exports.Editor = (0, react_1.forwardRef)((props, ref) => {
    const { id, idPrefix, disabled, children, schema, manifest, formData, onChange, onSubmit, options = {} } = props;
    const { disableFTEInputs, useViperForFTEInputs } = options;
    const element = (0, react_1.useRef)(null);
    const formRef = (0, react_1.useRef)(null);
    const handleSubmit = (0, react_1.useCallback)(() => onSubmit?.([]), [onSubmit]);
    const handleError = (0, react_1.useCallback)((errors) => onSubmit?.(errors), [onSubmit]);
    const rewrittenSchema = (0, react_1.useMemo)(() => schema && (0, react_json_schema_utils_1.rewriteSchema)(schema), [schema]);
    const isEmpty = (0, react_1.useMemo)(() => (0, isEmptySchema_1.isEmptySchema)(rewrittenSchema), [rewrittenSchema]);
    (0, react_1.useImperativeHandle)(ref, () => ({
        validateForm: () => {
            return formRef.current?.validateForm();
        },
    }), [formRef.current?.validate]);
    if (isEmpty) {
        return (react_1.default.createElement("div", { className: "squiz-ce-scope" },
            react_1.default.createElement(Preconfigured_1.default, { manifest: manifest })));
    }
    const featureFlags = { disableFTEInputs: !!disableFTEInputs, useViperForFTEInputs: !!useViperForFTEInputs };
    return (react_1.default.createElement(FeatureFlags_1.FeatureFlags.Provider, { value: featureFlags },
        react_1.default.createElement("div", { className: "squiz-ce-scope", ref: element },
            react_1.default.createElement(bootstrap_4_1.default, { ref: formRef, noHtml5Validate: true, showErrorList: false, id: id, idPrefix: idPrefix, idSeparator: exports.EDITOR_ID_SEPARATOR, className: "px-4", validator: react_json_schema_utils_1.defaultValidator, disabled: disabled, schema: rewrittenSchema, formData: formData, onChange: onChange, 
                // https://github.com/rjsf-team/react-jsonschema-form/pull/3855
                // extraErrors and extraErrorsBlockSubmit props are to workaround a bug where
                // "validateForm" won't trigger a re-render when going from having errors to not having errors.
                extraErrors: {}, extraErrorsBlockSubmit: true, widgets: {
                    CheckboxWidget: BooleanCustomWidget_1.default,
                }, templates: {
                    FieldTemplate: FieldTemplate_1.default,
                    ArrayFieldTemplate: ArrayFieldTemplate_1.default,
                    FieldErrorTemplate: FieldErrorTemplate_1.default,
                    DescriptionFieldTemplate: DescriptionFieldTemplate_1.default,
                    ObjectFieldTemplate: ObjectFieldTemplate_1.default,
                }, fields: {
                    SchemaField: SchemaField_1.SchemaField,
                }, onError: handleError, onSubmit: handleSubmit, experimental_defaultFormStateBehavior: {
                    allOf: 'populateDefaults',
                } }, children))));
});
